// @ts-nocheck

import React from 'react';
import styled from 'styled-components';

import theme from '../../styled-components/dark';
import { isLabelsTooLong } from '../../utils/basketItems';

const BetTitleWrapper = styled.p`
  text-align: center;
  color: #fff;
  width: 100%;
  font-size: 0.9em;
  margin: 0;
`;

const BetTitle = styled.span`
  color: ${theme.BasketCard.subLabelColor};
  font-size: 1em;
`;

const OutcomeTitle = styled.span`
  display: ${({ $shouldBreakLine }) => ($shouldBreakLine ? 'block' : 'inline-block')};
  font-size: 1.12em;
  font-weight: bold;
`;

type BasketCardTitleProps = {
  betTitle?: string;
  outcomeLabel?: string;
};

const BasketCardTitle = ({ betTitle, outcomeLabel }: BasketCardTitleProps) => {
  return (
    <BetTitleWrapper>
      <BetTitle>{betTitle}</BetTitle>{' '}
      <OutcomeTitle $shouldBreakLine={isLabelsTooLong([betTitle, outcomeLabel])}>{outcomeLabel}</OutcomeTitle>
    </BetTitleWrapper>
  );
};

export default React.memo<BasketCardTitleProps>(BasketCardTitle);
